module.exports = __webpack_public_path__ + "img/dynamic-22.df2e9cab.png";